<script>
  export let medium;
</script>

<!-- Check for medium -->

{#if medium === "Watercolor"}
  <svg class="fill-current w-6 h-6 text-smoke_xd dark:text-silver"
       viewBox="0 0 26 36"
       xmlns="http://www.w3.org/2000/svg">
    <path d="M24.23.213c-1.108-.68-2.78.26-5.259 2.956-2.106
             2.291-4.506 5.572-6.756 9.239C8.88 17.843 6.576
             22.946 6.103 25.87c-.199-.023-.401-.03-.606-.022-1.203.048-2.381.637-3.232
             1.616-1.222 1.405-1.252 3-1.249 3.267a8.43 8.43 0 01-.934 3.605.748.748 0
             00.31 1c1.251.676 2.68.824 4.051.496 1.321-.316 2.589-1.075
             3.59-2.227.47-.54.792-1.09.854-1.2.763-1.349.853-2.9.32-4.17 2.384-1.56
             6.103-6.107 9.59-11.789 2.25-3.666 4.089-7.29 5.178-10.207 1.282-3.432
             1.363-5.347.255-6.027zM7.586 31.669c-.03.051-.296.512-.681.955-1.4 1.609-3.433
             2.243-5.156 1.674a9.883 9.883 0
             00.764-3.545v-.04c0-.013-.024-1.226.881-2.267.582-.669 1.37-1.07
             2.163-1.102a2.295 2.295 0 011.718.65c.89.872 1.021 2.418.31
             3.675zm.799-4.68c-.021-.022-.35-.417-.84-.651.128-1.032.584-2.494
             1.295-4.219l2.825 1.735c-1.327 1.538-2.461 2.605-3.28 3.135zm4.247-4.298L9.44
             20.733c.308-.68.647-1.388 1.015-2.118l3.606 2.214c-.491.667-.97 1.29-1.43
             1.862zm9.797-16.595c-1.072 2.761-2.815 6.16-4.907 9.568a77.436 77.436 0
             01-2.585 3.946l-3.79-2.327a77.055 77.055 0 012.344-4.093c2.092-3.409
             4.333-6.501 6.309-8.707 2.433-2.716 3.439-2.96 3.639-2.98.072.186.31
             1.194-1.01 4.593z"/></svg>
{/if}
